var map = {
	"./abia.png": "2a2e",
	"./anambra.png": "6aea",
	"./corona.png": "9e86",
	"./crossriver.png": "63a2",
	"./fidelity.png": "4501",
	"./imo.png": "39f9",
	"./interswitch.png": "d6ff",
	"./uba.png": "be38",
	"./weppa.png": "75d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8695";